export default function getContactFullName(contact) {
  let fonction = '';
  if (contact?.fonction) {
    fonction = '(' + contact.fonction + ')';
  }
  return [contact?.prenom, contact?.nom, fonction].filter(Boolean).join(' ').trim();
}

export function getContactFullNameWithInfo(contact) {
  let fonction = '';
  let service = '';
  if (contact?.fonction) {
    fonction = `- ${contact.fonction}`;
  }
  if (contact?.service) {
    service = `- ${contact.service}`;
  }
  return [contact?.prenom, contact?.nom, service, fonction].filter(Boolean).join(' ').trim();
}
